import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const ElementsWrapper = styled.div`
	padding: 10px 42px;
	margin-bottom: 120px;
	display: grid;
	gap: 30px;
`;

export const Hr = styled.hr`
	border: 0.5px solid ${tokens.color_gray_medium};
	margin: 0 42px 20px 42px;
`;
